// Window events that open / close the shared checkout modal. CheckoutPage
// already fires `close-checkout-modal` once an order is placed.
export const OPEN_CHECKOUT_MODAL = 'open-checkout-modal';
export const CLOSE_CHECKOUT_MODAL = 'close-checkout-modal';

// Auth-modal redirect sentinel: "after login, open the checkout modal"
// instead of navigating to a route.
export const CHECKOUT_MODAL_REDIRECT = '__checkout_modal__';

// `?checkout=open` on any storefront page reopens the checkout modal. Payment
// return pages use it, since they come back by URL (often in another tab)
// and can't carry router state.
export const CHECKOUT_MODAL_PARAM = 'checkout';

// `?payment_failed=1` on the checkout URL tells checkout the customer is back
// from a declined gateway payment, so it can say why.
export const PAYMENT_FAILED_PARAM = 'payment_failed';

export const loadCheckoutModule = () => import('@features/checkout/CheckoutPage.jsx');

export function openCheckoutModal() {
  window.dispatchEvent(new CustomEvent(OPEN_CHECKOUT_MODAL));
}
